import { Box } from '@mui/material';
import { Role, RolesColumn } from '../../../../../../../../model/rolesAndPerms.model';

export const ModifiedByCell = ({ row, column }: { row: Role; column: RolesColumn }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box
        sx={{
          display: 'flex',
          marginRight: '8px',
          justifyContent: 'center',
          alignItems: 'center',
          width: '28px',
          height: '28px',
          borderRadius: '50%',
          overflow: 'hidden',
        }}
      >
        <img src={row.updatedBy.profilePicture} alt='Profile' width={'100%'} height={'100%'} />
      </Box>
      {/* {row[column.id as keyof typeof row]} */}
      {row.updatedBy.name}
    </Box>
  );
};
